/**
 * "Mareczek is working…" typing-dots bubble, shared by the private chat
 * panel and the shared chat rail (ZPL-152). Styled like an incoming message
 * so it reads as "a reply is coming".
 */
export function ThinkingBubble({
	label,
	text,
}: {
	label: string
	/** Latest per-turn narration from the agent (ZPL-294); dots-only when null. */
	text?: string | null
}) {
	return (
		<div className="flex items-end gap-1.5 self-start">
			<div className="max-w-[75%] px-3 py-2 rounded-lg bg-card border border-border text-foreground rounded-bl-sm">
				<span
					role="status"
					aria-label={label}
					className="flex items-center gap-1"
				>
					<span
						className="h-1.5 w-1.5 rounded-full bg-muted-foreground/60 animate-bounce"
						style={{ animationDelay: "-0.3s" }}
					/>
					<span
						className="h-1.5 w-1.5 rounded-full bg-muted-foreground/60 animate-bounce"
						style={{ animationDelay: "-0.15s" }}
					/>
					<span className="h-1.5 w-1.5 rounded-full bg-muted-foreground/60 animate-bounce" />
				</span>
				{text ? (
					<p className="mt-1 max-w-56 truncate text-xs text-muted-foreground">
						{text}
					</p>
				) : null}
			</div>
		</div>
	)
}
